import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { Card, CardContent } from '../components/Card';
export function Contact() {
  return <div className="container mx-auto px-4 py-12" data-id="element-459">
      <div className="text-center mb-12" data-id="element-460">
        <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-461">Contact</h1>
        <p className="text-xl text-gray-600" data-id="element-462">
          Heb je een vraag of wil je gewoon even hallo zeggen?
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 max-w-6xl mx-auto" data-id="element-463">
        {/* Contact Info Sidebar */}
        <div className="space-y-8" id="bereikbaarheid" data-id="element-464">
          <Card variant="outlined" data-id="element-465">
            <CardContent data-id="element-466">
              <h2 className="font-bold text-lg mb-6" data-id="element-467">
                Waar kan je ons vinden?
              </h2>
              <ul className="space-y-6" data-id="element-468">
                <li className="flex items-start" data-id="element-469">
                  <MapPin className="text-gray-400 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-470" />
                  <div data-id="element-471">
                    <span className="font-medium block text-gray-900" data-id="element-472">
                      Adres
                    </span>
                    <span className="text-gray-600" data-id="element-473">
                      Louis Melsensstraat 17
                      <br data-id="element-474" />
                      3000 Leuven
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-475">
                  <Phone className="text-gray-400 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-476" />
                  <div data-id="element-477">
                    <span className="font-medium block text-gray-900" data-id="element-478">
                      Telefoon
                    </span>
                    <span className="text-gray-600" data-id="element-479">+32 473 52 48 85</span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-480">
                  <Mail className="text-gray-400 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-481" />
                  <div data-id="element-482">
                    <span className="font-medium block text-gray-900" data-id="element-483">
                      Email
                    </span>
                    <a href="mailto:welkom@demaekerij.be" className="text-gray-600 hover:underline" data-id="element-484">
                      welkom@demaekerij.be
                    </a>
                  </div>
                </li>
              </ul>

              {/* Map */}
              <div className="mt-6 rounded-lg overflow-hidden border border-gray-200" data-id="element-485">
                <iframe title="De Maekerij locatie" src="https://www.openstreetmap.org/export/embed.html?bbox=4.6950%2C50.8770%2C4.7010%2C50.8810&layer=mapnik&marker=50.8790%2C4.6980" width="100%" height="200" style={{
                border: 0
              }} loading="lazy" data-id="element-486" />
              </div>
            </CardContent>
          </Card>

          <Card variant="outlined" data-id="element-487">
            <CardContent data-id="element-488">
              <h2 className="font-bold text-lg mb-6 flex items-center" data-id="element-489">
                <Clock className="text-gray-400 mr-2" size={20} data-id="element-490" />
                Openingsuren
              </h2>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-491">
                <li className="flex justify-between" data-id="element-492">
                  <span data-id="element-493">Maandag</span>
                  <span data-id="element-494">Gesloten</span>
                </li>
                <li className="flex justify-between" data-id="element-495">
                  <span data-id="element-496">Dinsdag</span>
                  <span data-id="element-497">10:00 - 18:00</span>
                </li>
                <li className="flex justify-between" data-id="element-498">
                  <span data-id="element-499">Woensdag</span>
                  <span data-id="element-500">10:00 - 18:00</span>
                </li>
                <li className="flex justify-between" data-id="element-501">
                  <span data-id="element-502">Donderdag</span>
                  <span data-id="element-503">10:00 - 22:00</span>
                </li>
                <li className="flex justify-between" data-id="element-504">
                  <span data-id="element-505">Vrijdag</span>
                  <span data-id="element-506">10:00 - 18:00</span>
                </li>
                <li className="flex justify-between" data-id="element-507">
                  <span data-id="element-508">Zaterdag</span>
                  <span data-id="element-509">10:00 - 18:00</span>
                </li>
                <li className="flex justify-between" data-id="element-510">
                  <span data-id="element-511">Zondag</span>
                  <span data-id="element-512">Gesloten</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* Contact Form */}
        <div className="lg:col-span-2" id="contactformulier" data-id="element-513">
          <div className="bg-gray-50 p-8 rounded-lg border border-gray-200" data-id="element-514">
            <h2 className="font-bold text-2xl mb-6" data-id="element-515">Stuur ons een bericht</h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-516">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-517">
                <Input label="Naam" placeholder="Jouw naam" required data-id="element-518" />
                <Input label="Email" type="email" placeholder="jouw@email.be" required data-id="element-519" />
              </div>

              <Input label="Onderwerp" placeholder="Waar gaat het over?" required data-id="element-520" />

              <div className="space-y-1" data-id="element-521">
                <label className="block text-sm font-medium text-gray-700" data-id="element-522">
                  Bericht <span className="text-red-500" data-id="element-523">*</span>
                </label>
                <textarea rows={6} className="w-full border border-gray-300 rounded-md py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-gray-300" placeholder="Typ hier je bericht..." required data-id="element-524"></textarea>
              </div>

              <div className="pt-2" data-id="element-525">
                <Button variant="primary" size="large" type="submit" data-id="element-526">
                  Verstuur bericht
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
}